module.exports = __webpack_public_path__ + "img/logo-dark.ddd20849.png";